import * as React from "react";
import ModalRegistrazione from "@src/components/frontend/modals/ModalRegistrazione";
import FormSelect from "@src/components/ui/FormSelect";
import FormCheckBox from "@src/components/ui/FormCheckBox";
import FormInput from "@src/components/ui/FormInput";

interface Props {
    header: string,
    onSave?: any,
    onEdit?: any,
    onCancel?: any
    competenza?: any,
    competenza_nome?: any,
    competenza_file?: any,
    competenza_filename?: any,
    items?: any,
}

interface State {
    _modal_competenza_list?: string | null,
    _modal_competenza?: string | null,
    _modal_competenza_nome?: string | null,
    _modal_competenza_certificata?: boolean,
    _modal_competenza_titolo_certificazione?: string,
    _modal_competenza_filename?: string | null,
    _modal_competenza_file?: any,
    isEdit?: any,
}

export default class ModalCompetenza extends React.Component<Props, State> {

    constructor(props) {
        super(props)

        console.log('constructor', this.props);

        this.handleUploadFile = this.handleUploadFile.bind(this);

        if(this.props.competenza !== undefined && this.props.competenza !== null) {

            // let competenzeEsistenti = [
            //     "Photoshop",
            //     "Illustrator",
            //     "InDesign",
            //     "InVision"
            // ];

            let competenze = this.props.items;
            let competenzeEsistenti = competenze.map((item) => item.value);

            let choosenCompetenza = competenze.filter((item) => item.value == this.props.competenza.nome);


            console.log('competenze', competenze);
            console.log('competenzeEsistenti', competenzeEsistenti);
            console.log('choosenCompetenza', choosenCompetenza);

            this.state = {
                _modal_competenza: (choosenCompetenza.length > 0) ? choosenCompetenza[0].key : this.props.competenza.nome,
                _modal_competenza_nome: this.props.competenza.nome,
                _modal_competenza_certificata: this.props.competenza.certificata,
                _modal_competenza_titolo_certificazione: this.props.competenza.titolo,
                _modal_competenza_filename: (this.props.competenza.hasOwnProperty('filename')) ? this.props.competenza.filename : null,
                _modal_competenza_file: null,
                isEdit: true,
            }


        } else {
            this.state = {
                _modal_competenza: "",
                _modal_competenza_nome: "",
                _modal_competenza_filename: null,
                _modal_competenza_file: null,
                _modal_competenza_certificata: false,
                _modal_competenza_titolo_certificazione: "",
                isEdit: false,
            }
        }

        console.log('this.state', this.state);
    }

    handleChange(field, value) {
        console.log('field,value', field, value);

        if(field == '_modal_competenza_list') {
            this.setState({
                _modal_competenza: ''
            })
        }
        this.setState({
            [field]: value
        });
    }

    onSave() {


        let result = {
            nome: null, key: null,
            competenza: (this.state._modal_competenza ? this.state._modal_competenza : this.state._modal_competenza_list),
            certificata: this.state._modal_competenza_certificata,
            file: this.state._modal_competenza_file,
            filename: this.state._modal_competenza_filename,
            titolo: this.state._modal_competenza_titolo_certificazione
        };

        if(result.competenza === undefined || result.competenza === '' || result.competenza == null || result.competenza == 'null') {
            alert('Nome competenza inserito non valido.');
            return;
        }

        console.log('danilo', this.state._modal_competenza_list);
        console.log('danilo', this.props.items.filter((item) => item.key == this.state._modal_competenza_list));

        let competenza_nome = this.props.items.filter((item) => item.key == this.state._modal_competenza_list);

        if(competenza_nome.length == 0) {
            if(this.state.isEdit === true) {
                competenza_nome = (this.state._modal_competenza_list ? this.state._modal_competenza_list : this.state._modal_competenza);
            } else {
                competenza_nome = (this.state._modal_competenza ? this.state._modal_competenza : this.state._modal_competenza_list);
            }
        } else {
            competenza_nome = competenza_nome[0].value;
        }

        result.nome = competenza_nome;

        if(this.state.isEdit === false) {
            console.log('onSave');
            if(this.props.onSave)
                this.props.onSave(result);
        } else {
            console.log('onEdit');

            result.key = this.props.competenza.key;
            if(this.props.onEdit)
                this.props.onEdit(result);
        }
    }

    handleUploadFile(ev) {
        ev.preventDefault();
        this.setState({
            showUploadButton: false,
            uploadInProgress: true
        });

        this.setState({
            _modal_competenza_file: this.fileUploadBtn.files[0],
            _modal_competenza_filename: document.getElementById('uploadCompetenzaUser').value.replace('C:\\fakepath\\', '')
        });
    }

    render() {
        let competenze = [
            {
                key: "Photoshop",
                value: "Photoshop"
            },
            {
                key: "Illustrator",
                value: "Illustrator"
            },
            {
                key: "InDesign",
                value: "InDesign"
            },
            {
                key: "InVision",
                value: "InVision"
            }
        ];

        let competenzeEsistenti = [
            "Photoshop",
            "Illustrator",
            "InDesign",
            "InVision"
        ];


        let competenze = this.props.items;



        let competenzeEsistenti = competenze.map((item) => item.key);

        console.log('competenzeEsistenti', competenzeEsistenti);

        return (
            <ModalRegistrazione header={this.props.header} onSave={this.onSave.bind(this)} onCancel={this.props.onCancel}>
                <div className={"block-qa"}>
                    <span>Seleziona nuova competenza</span>
                    <div className={"answer"}>
                        <FormSelect values={competenze} placeholder={"Selezionare"} name="_modal_competenza_list" value={this.state._modal_competenza} onChange={this.handleChange.bind(this)} />
                        <h4>La tua competenza non è in elenco? Scrivila qui sotto</h4>
                        <div style={{maxWidth: "300px"}}>
                            {
                                (competenzeEsistenti.indexOf(this.state._modal_competenza) === -1) ?
                                <FormInput type={"text"} placeholder={"Aggiungi la tua competenza"} name="_modal_competenza" value={this.state._modal_competenza} onChange={this.handleChange.bind(this)} />
                                : <FormInput type={"text"} placeholder={"Aggiungi la tua competenza"} name="_modal_competenza"  onChange={this.handleChange.bind(this)} />
                            }

                        </div>
                        <FormCheckBox name="_modal_competenza_certificata" value={this.state._modal_competenza_certificata} onChange={this.handleChange.bind(this)}>COMPETENZA CERTIFICATA</FormCheckBox>
                    </div>
                </div>
                <div className="margin" style={{ marginTop: "30px" }}></div>
                <div className={"block-qa"}>
                    <span>Certificazione della competenza</span>
                    <div className={"answer"}>
                        <h4>Hai una certificazione per questa competenza? Allegala!</h4>
                        <br />
                        <div className={"btn-block"} style={ { position: 'relative' } }>
                            <form id="uploadCompetenzaForm" ref={form => this.uploadCompetenzaForm = form} method="post" style={{ opacity: 0, zIndex: 9999, cursor: 'pointer' }} >
                                <input ref={input => this.fileUploadBtn = input} onChange={this.handleUploadFile} type="file" id="uploadCompetenzaUser" name="competenzaUser" accept=".pdf,.png,.jpg,.jpeg,.xls,.doc,.docx" />
                            </form>
                            <button className={"btn-load-file"} style={ { position: 'absolute', top: '-10px', zIndex: 1 } }>
                                <span className="icon-upload"></span>
                                Carica file
                            </button>
                        </div>
                        <br />
                        {
                            this.state._modal_competenza_filename &&
                            this.state.isEdit == false &&
                            <span className="info-load-file">File: <strong>[{ this.state._modal_competenza_filename }]</strong></span>
                        }
                        {
                            this.state._modal_competenza_filename &&
                            this.state.isEdit == true &&
                            <span className="info-load-file">File: <strong><a href={this.state._modal_competenza_filename} target="_blank">[{ this.state._modal_competenza_filename.substr(this.state._modal_competenza_filename.lastIndexOf('/') + 1) }]</a></strong></span>
                        }
                    </div>
                </div>
                <div className="margin" style={{ marginTop: "50px" }}></div>
                <div className={"block-qa"}>
                    <span>Titolo della competenza</span>
                    <div className={"answer"}>
                        <h4>Nome della tua certificazione (pubblicato online).</h4>
                        <div style={{maxWidth: "300px"}}>
                            <FormInput type={"text"} placeholder={"Nome"} name="_modal_competenza_titolo_certificazione" value={this.state._modal_competenza_titolo_certificazione} onChange={this.handleChange.bind(this)} />
                        </div>
                    </div>
                </div>
            </ModalRegistrazione>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/ModalCompetenza.tsx